module.exports = __webpack_public_path__ + "img/top-bar.c854c28b.jpg";